import { useEffect, useState } from "react";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import { getAuthMethod } from "../../modules/helper";
import CountToday from "./components/CountToday";
import { Container } from "react-bootstrap";
import Laoder from "../../components/loading/Loader";
import useUserInformation from "../../hooks/useUserInformation";
import CountWithProvince from "../districtManager/components/CountWithProvince";

function TodayShipments() {
  const { isDistrictManger } = useUserInformation();

  const [loading, setLoading] = useState(true);
  const [countShipments, setcountShipments] = useState({});
  const [provinceList, setProvinceList] = useState([]);

  const getShipmentCount = async signal => {
    setLoading(true);

    const response = await getAuthMethod(
      "/supervisor/v1/shipment-count",
      undefined,
      signal
    );

    if (response?.status === 200) {
      setcountShipments(() => response.data.result);
    }

    if (signal.aborted === false) {
      setLoading(false);
    }
  };

  const getProvineWithCount = async signal => {
    const response = await getAuthMethod(
      "/district-manager/v1/shipment-with-provinces",
      undefined,
      signal
    );

    if (response?.status === 200) {
      setProvinceList(response.data.result);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    getShipmentCount(controller.signal);

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (isDistrictManger === true) {
      const controller = new AbortController();
      getProvineWithCount(controller.signal);

      return () => controller.abort();
    }
  }, []);

  return (
    <MainMenu>
      <Container>
        {loading === true && <Laoder />}
        {loading === false && (
          <main className="mt-3">
            <CountToday countShipments={countShipments} />
            {isDistrictManger && <CountWithProvince provinces={provinceList} />}
          </main>
        )}
      </Container>
    </MainMenu>
  );
}

export default TodayShipments;
